import React from 'react';

export const AmbientLight = ({
  height = '20',
  width = '20',
}: {
  height?: string;
  width?: string;
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 20 20"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.44159 0.857544H10.5499V3.87254H9.44159V0.857544ZM14.4324 5.47588L16.5641 3.34421L17.3474 4.12838L15.2149 6.26004L14.4324 5.47588ZM0.857422 10.5509H3.87242V9.44254H0.857422V10.5509ZM16.1274 10.5509V9.44254H19.1424V10.5509H16.1274ZM7.99992 16.6359H12.0541V17.7442H7.99992V16.6359ZM8.58742 19.2192H11.4699V18.1109H8.58742V19.2192ZM3.49326 3.34421L2.70992 4.12838L4.84242 6.26004L5.62492 5.47588L3.49326 3.34421ZM12.9208 14.1334C14.2775 13.2044 15.061 11.643 14.9949 10C15.0405 8.66184 14.5289 7.3647 13.5821 6.4179C12.6353 5.47109 11.3381 4.95948 9.99992 5.00504C8.66172 4.95948 7.36458 5.47109 6.41777 6.4179C5.47097 7.3647 4.95936 8.66184 5.00492 10C4.96616 11.6375 5.74863 13.1859 7.08992 14.1259L7.20409 14.88C7.28572 15.4223 7.75158 15.8233 8.29992 15.8234H11.7241C12.279 15.8237 12.7485 15.4134 12.8224 14.8634L12.9208 14.1334ZM13.8866 10C13.9253 8.95785 13.5283 7.94659 12.7908 7.20914C12.0534 6.47169 11.0421 6.07465 9.99992 6.11338C8.95772 6.07465 7.94647 6.47169 7.20902 7.20914C6.47156 7.94659 6.07453 8.95785 6.11326 10C6.06352 11.4357 6.8383 12.7736 8.10826 13.445L8.29992 14.715H11.7241L11.8908 13.445C13.1826 12.7965 13.9666 11.4433 13.8866 10Z"
        fill="#000E26"
      />
    </svg>
  );
};
